import { render, staticRenderFns } from "./ComunicazioniList.vue?vue&type=template&id=962edba8&"
import script from "./ComunicazioniList.vue?vue&type=script&lang=js&"
export * from "./ComunicazioniList.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

component.options.__file = "ComunicazioniList.vue"
export default component.exports